import { GDT, IDisplayItem } from "@/types";

export class DisplayItem implements IDisplayItem {
  private readonly _data: IDisplayItem;
  readonly _column: GDT.ColumnDefinition | undefined;
  constructor(data: IDisplayItem, column?: GDT.ColumnDefinition) {
    this._data = data;
    this._column = column;
  }

  get value() {
    return this._data.value;
  }

  get name() {
    return this.columnDefinition?.columnName;
  }

  get type() {
    return this.columnDefinition?.type;
  }

  get columnDefinition() {
    return this._column;
  }
}
